module.exports = __webpack_public_path__ + "static/img/home1-bg6-content.596f14a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home1-bg6-content.png
// module id = +YYH
// module chunks = 0